import React from 'react';
import { FiChevronDown } from 'react-icons/fi';

import scrollTo from '../../utils/scrollTo';

import { Container, Content, LearnMore, HalfRectangle } from './styles';

interface ImageHeaderProps {
  title: string;
  goToDiv: string;
}

const ImageHeader: React.FC<ImageHeaderProps> = ({
  title,
  goToDiv,
}: ImageHeaderProps) => {
  return (
    <Container>
      <HalfRectangle
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 6005 306"
        fill="#fff"
      >
        <path d="M0,306H6005V0Z" />
      </HalfRectangle>

      <Content>
        <h1>{title}</h1>
      </Content>

      <LearnMore>
        <div>
          <button type="button" onClick={() => scrollTo(goToDiv)}>
            <p>SAIBA MAIS</p>
            <FiChevronDown />
          </button>
        </div>
      </LearnMore>
    </Container>
  );
};

export default ImageHeader;
